module.exports = __webpack_public_path__ + "images/amex.png";